import { css } from '@emotion/react'
import { Dropzone, DropzoneProps } from '@mantine/dropzone'
import { motion } from 'motion/react'
import { forwardRef } from 'react'
import toast from 'react-hot-toast'

export interface AttachmentDropzoneProps extends DropzoneProps {}

export default forwardRef<HTMLDivElement, AttachmentDropzoneProps>(function AttachmentDropzone(
	{ children, ...props },
	ref
) {
	return (
		<Dropzone
			ref={ref}
			{...props}
			onReject={() => {
				toast.error('暂不支持该文件类型')
				toast('请在即刻App中重试')
			}}
			css={css`
				position: relative;
			`}
			activateOnClick={false}
		>
			{children}
			<Dropzone.Accept>
				<motion.div
					initial={{
						opacity: 0,
					}}
					animate={{
						opacity: 1,
					}}
					exit={{
						opacity: 0,
					}}
					css={css`
						border: 1px dashed var(--tint-separator);
						border-radius: 8px;
						color: var(--tint-primary);
						font-size: 20px;
						font-weight: 500;

						position: absolute;
						inset: -20px;
						z-index: 1;

						display: flex;
						justify-content: center;
						align-items: center;
					`}
				>
					拖拽到此处上传
				</motion.div>
			</Dropzone.Accept>
		</Dropzone>
	)
})
